import common from "@page/common/js/common";
import popup from "@global/components/Home/popup"; //首頁popup
import globalLayout from "@global/components/Home/globalLayout"; //公版模組
require("@global/vendors/slick");

globalLayout({
  banner: {
    isopen: true,
    opts: {
      dots: false,
      arrows: false,
      speed: 800,
      autoplay: true,
      autoplaySpeed: 3000,
    },
    squareOpts: {
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      arrows: true,
      speed: 800,
      responsive: [
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            dots: false,
          },
        },
      ],
    },
    fullbanner: {
      play: 5000,
    },
  },
  popupOpen: true,
});

setTimeout(function () {
  $("#page-home #main-wrap").css({ visibility: "visible" });

  var nowTime = new Date().getTime();
  var startTime = new Date(2021, 0, 19, 18, 0, 0).getTime();
  var endTime = new Date(2021, 1, 6, 9, 0, 0).getTime();

  if (nowTime >= startTime && nowTime < endTime) {
    $("#page-home #main-content").after(
      "<div class='container'><div class='video-container'><iframe width='560' height='315' src='https://www.youtube.com/embed/dLTaF76eJ0E' title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe></div></div>"
    );
  }
}, 100);
